/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Standings_PublicInputs */



/**
* | output |
* | --- |
* | "Public" |
*
* @param {Tournament_Standings_PublicInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_standings_public = /** @type {((inputs?: Tournament_Standings_PublicInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Standings_PublicInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Public")
	if (locale === "es") return /** @type {LocalizedString} */ ("Público")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Público")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblico")
	return /** @type {LocalizedString} */ ("Public")
});